import type { DirectComposerPendingFile } from '@/components/Messenger/types/chatMessageTypes';
import { compressImageToJfif } from './compressImageToJfif';
import { messengerImageAsAttachmentFile } from '../attachments/messengerImageAsAttachmentFile';
import { messengerAnonymizedInlineImageFile } from '../attachments/messengerInlineImageUploadFileName';
import { MESSENGER_MAX_FILES_PER_MESSAGE } from './messengerAttachmentLimits';

function isImageFile(f: File): boolean {
  return Boolean(f.type && f.type.startsWith('image/'));
}

export async function prepareDirectComposerFilesForUpload(
  items: readonly DirectComposerPendingFile[]
): Promise<File[]> {
  const out: File[] = [];
  for (const item of items.slice(0, MESSENGER_MAX_FILES_PER_MESSAGE)) {
    if (item.source === 'add_photo') {
      try {
        out.push(await compressImageToJfif(item.file));
      } catch {
        out.push(messengerAnonymizedInlineImageFile(item.file));
      }
      continue;
    }

    if (item.source === 'add_file') {
      if (isImageFile(item.file)) {
        out.push(messengerImageAsAttachmentFile(item.file));
      } else {
        out.push(item.file);
      }
      continue;
    }

    if (item.sendAsAttachment) {
      if (isImageFile(item.file)) {
        out.push(messengerImageAsAttachmentFile(item.file));
      } else {
        out.push(item.file);
      }
    } else if (isImageFile(item.file)) {
      try {
        out.push(await compressImageToJfif(item.file));
      } catch {
        out.push(messengerAnonymizedInlineImageFile(item.file));
      }
    } else {
      out.push(item.file);
    }
  }
  return out;
}
